import React from 'react';
import Button from '@material-ui/core/Button';
import SearchIcon from '@material-ui/icons/Search';
import moment from 'moment';
import { Select, MenuItem, createStyles, Theme, withStyles, OutlinedInput, Grid, Tooltip, Input, ListSubheader } from '@material-ui/core';

import { KeyboardDatePicker, TimePicker } from '@material-ui/pickers';
import CalendarToday from '@material-ui/icons/CalendarToday';
import PrintIcon from '@material-ui/icons/Print';
import QueryBuilder from '@material-ui/icons/QueryBuilder';
import DeleteIcon from '@material-ui/icons/DeleteOutlineOutlined';

import screeningStyles from './screeningReport.module.css';
import commonStyles from '../common/common.module.css';
import InputAdornment from '@material-ui/core/InputAdornment';

import TextField from '@material-ui/core/TextField';
import AwbInfoSearchComponent from '../awbInfo/awbInfoSearch/AwbInfoSearchComponent';


interface ScreeningReportFilterComponentProps {
  classes: any;
  fromDate: Date;
  fromTime: Date;
  toDate: Date;
  toTime: Date;
  airlinesVal: string;
  flightVal: string;
  listMeasure: Array<string>;
  handleAirlineChange: (event: any) => void;
  handleFlightChange: (event: any, type: string) => void;
  getScreeningReport: () => void;
  print: () => void;
  csv: () => void;
  flightFilter: Array<string>;
  bookedFlightFilter: Array<string>;
  bookedFlightVal: string;
  airlines: Array<string>;
  fromDateChange: (date: Date) => void;
  fromTimeChange: (date: Date) => void;
  toDateChange: (date: Date) => void;
  toTimeChange: (date: Date) => void; 
  awbNumber: string;
  handleChangeKeyword: (event: any) => void;
  clear: () => void;
  selectedMeasures: Array<string>;
  handleChangeMeasureFilter: Function;
  buttonState: boolean;
  loading?: boolean;
};

const styles = (theme: Theme) =>
  createStyles({
    group: {
      display: 'flex',
      flexDirection: 'row',
      flexWrap: 'nowrap'
    },
    inputLabel: {
      fontSize: '10px !important',
      paddingLeft: '12px !important',
    },
    measureSelect: {
      width: '12%'
    }
  });

const screeningReportFilterComponent = (props: ScreeningReportFilterComponentProps) => {

  const MenuProps = {
    PaperProps: {
      style: {
        width: 250,
      },
    },
  };
  return (
    <div>
      <div className={ commonStyles.searchWrapperOuter }>
        <AwbInfoSearchComponent
          awbNumber={ props.awbNumber }
          label = 'AirwayBill'
          handleChangeAwbNumber={ props.handleChangeKeyword }
          search={ props.getScreeningReport }
          type='screening'
          buttonState={ props.buttonState }
        />
      </div>

      <div className={ screeningStyles.filters }>
        <div className={ `${commonStyles.wrapper} ${commonStyles.w100}`}  >
          <h3 className={ commonStyles.header }> Filter By </h3>
          <Grid container spacing={2} className={ screeningStyles.screening_filterBy_date } >
            <Grid item md={3} sm={3} xs={6} className={ screeningStyles.grid_item }>
              <div className={ commonStyles.inputLabel }>Date</div>
              <KeyboardDatePicker
                className={ `${ screeningStyles.dateInput } ${ props.classes.inputEnd }` }
                format='DD MMMM YYYY'
                value={ props.fromDate }
                onChange={(date: any) => props.fromDateChange(date)}
                InputProps={{
                  className: screeningStyles.datePickerInput,
                  classes: { root: props.classes.inputtextField },
                }}
                fullWidth
                autoOk
                inputVariant="outlined"
              />
            </Grid>

            <Grid item  md={2} sm={2} xs={6} className={ `${ screeningStyles.grid_item } ${ screeningStyles.pr0 } ${ screeningStyles.by_time }` }>
              <div className={ commonStyles.inputLabel }>Time</div>
              <TimePicker clearable 
                format={'HH:mm'}
                className={ screeningStyles.timeInput }
                value={ moment(props.fromTime, 'HH:mm:ss') }
                onChange={ (date: any) => props.fromTimeChange(date) }
                autoOk
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end" >
                      <QueryBuilder color='primary' />                      
                    </InputAdornment>
                    ),
                  classes: { root: props.classes.inputtextField },
                }}
                fullWidth
                inputVariant="outlined"
              />
            </Grid>

            <Grid item className={ screeningStyles.grid_item_to }>
              <div className={ screeningStyles.insideGrid1 }>TO</div>
            </Grid>

            <Grid item md={3} sm={3} xs={6} className={ screeningStyles.grid_item }>
              <div className={ commonStyles.inputLabel }>Date</div>
              <KeyboardDatePicker
                className={ screeningStyles.dateInput }
                format='DD MMMM YYYY'
                value={ props.toDate }
                onChange={(date: any) => props.toDateChange(date)}
                InputProps={{
                  className: screeningStyles.datePickerInput,
                  classes: { root: props.classes.inputtextField },
                }}
                fullWidth
                autoOk
                inputVariant="outlined"
              />
            </Grid>

            <Grid item  md={2} sm={3} xs={6} className={ `${ screeningStyles.grid_item } ${ screeningStyles.by_time }` }>
              <div className={ commonStyles.inputLabel }>Time</div>
              <TimePicker
                clearable
                format={'HH:mm'}
                className={ screeningStyles.timeInput }
                value={moment(props.toTime, 'HH:mm:ss')}
                onChange={ (date: any) => props.toTimeChange(date) }
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end" >
                      <QueryBuilder color='primary' />
                    </InputAdornment>
                  ),
                  classes: { root: props.classes.inputtextField },
                }}
                fullWidth
                autoOk
                inputVariant="outlined"
              />
            </Grid>

              <Grid item md={3} sm={3} xs={6} className={ screeningStyles.grid_item } >
                <div className={ commonStyles.inputLabel }>Airline</div>
                <div className={ screeningStyles.filterItem }>
                  <Select
                    native
                    className={ `${ screeningStyles.selectFilter } ${ props.classes.inputtextField }`} 
                    value={props.airlinesVal}
                    onChange={props.handleAirlineChange}
                    variant="outlined"
                    >

                    <option value={''}>All Airlines</option>
                    {props.airlines.map((val: string, i: number) => {
                      return (
                        <option value={val} key={i}>
                          {val}
                        </option>
                      );
                    })}

                  </Select>
                </div>
              </Grid>

              <Grid item md={3} sm={3} xs={6} className={ [screeningStyles.grid_item, props.classes.measureSelect].join(" ") } >
                <div className={ commonStyles.inputLabel }>Measure</div>
                <div className={ screeningStyles.filterItem }>
                <Select 
                  multiple            
                  onChange={ (event)=> props.handleChangeMeasureFilter(event) }
                  className={ `${ screeningStyles.selectFilter } ${ props.classes.inputtextField }`} 
                  value={ props.selectedMeasures }
                  MenuProps={ MenuProps }
                  fullWidth
                  variant="outlined"
                >
                  <ListSubheader className={ props.classes.listSubheader }/>

                  { props.listMeasure.map((type: any)=> (
                    <MenuItem 
                      key={ type } 
                      value={ type } 
                      classes = {{
                        root: props.classes.root,
                        selected: props.classes.selected
                    }}
                    className={ props.classes.menuItem }
                    >
                      { type }
                    </MenuItem>
                  ))}
                </Select>
                </div>
              </Grid>

              <Grid item md={3} sm={3} xs={6} className={ screeningStyles.grid_item } >
                <div className={ commonStyles.inputLabel }>Booked Flight</div>
                <div className={ screeningStyles.filterItem }>
                  <Select
                    native
                    className={ `${ screeningStyles.selectFilter } ${ props.classes.inputtextField }`} 
                    onChange={(e) => props.handleFlightChange(e, 'bkd')}
                    value={props.bookedFlightVal}
                    variant="outlined"
                    >

                    <option value={''}>All Booked Flights</option>
                    {props.bookedFlightFilter.map((val: string, i: number) => {
                      return (
                        <option value={val} key={i}>
                          {val}
                        </option>
                      );
                    })}

                  </Select>
                </div>
              </Grid>

              <Grid item md={3} sm={3} xs={6} className={ `${ screeningStyles.grid_item } ${ screeningStyles.screened }` } >
                <div className={ commonStyles.inputLabel }>Screened For Flight</div>
                <div className={ screeningStyles.filterItem }>
                  <Select
                    native
                    className={ `${ screeningStyles.selectFilter } ${ props.classes.inputtextField }`} 
                    onChange={(e) => props.handleFlightChange(e, 'for')}
                    value={props.flightVal}
                    inputProps={{ classes:{ root: props.classes.select }
                  }}
                  variant='outlined'
                  >

                    <option value={''}>All Screened Flights</option>
                    {props.flightFilter.map((val: string, i: number) => {
                      return (
                        <option value={val} key={i}>
                          {val}
                        </option>
                      );
                    })}

                  </Select>
                </div>
              </Grid>
              
              <Grid item className={ `${ screeningStyles.buttonWrapper } ${ commonStyles.mlauto }`}>
                <Button
                  color='primary'
                  variant='contained'
                  onClick={ props.getScreeningReport }
                  className={ screeningStyles.button }
                  style={{marginRight: '10px'}}
                  disabled={ props.buttonState || props.loading }
                >
                <SearchIcon />
              </Button>
              <Tooltip title="clear">
                <Button
                  color='primary'
                  variant='contained'
                  onClick={ props.clear }
                  className={ `${ screeningStyles.button } ${ screeningStyles.clrFilterBtn }` }
                  disabled={ props.loading }
                >
                  Clear
                </Button>
              </Tooltip>
            </Grid>
          </Grid>
        </div>

        <div className={ screeningStyles.buttonClass }>
            <Button onClick={props.print} color='primary' disabled={ props.loading }>
            <PrintIcon className={ screeningStyles.svgIcon } />
          </Button>
          <Button onClick={props.csv} color='primary' disabled={ props.loading }>
            Export CSV
          </Button>
        </div>

      </div>

    </div>
  );
};

export default withStyles(styles)(screeningReportFilterComponent);
